export const SIDEBAR_WIDTH = 306;
